import { getTypographyMetric } from '../../../../../../../../helpers';
import { useTheme } from 'styled-components';
import { Radio } from 'front-commons/ds/components';
import { Typography } from 'hype-ds';
import { HeaderSelectorSkeletonsRender } from '../../../Skeleton';
import type { PosListProps } from './interfaces';

export function PosList({ disabled, loading, posList, posNotFound, selectedPosId, onChangePos }: PosListProps) {
	const { fontSizes } = useTheme();

	if (posNotFound) {
		return (
			<Typography
				data-header-text="PosList-metric-1"
				textAlign="inherit"
				fontSize={getTypographyMetric(fontSizes['16'])}
				fontWeight="400"
				lineHeight={getTypographyMetric(fontSizes['24'])}
				color="--red-900"
			>
				Farmácia não encontrada
			</Typography>
		);
	}

	return (
		<HeaderSelectorSkeletonsRender posList={loading}>
			<Radio
				data={posList.map(({ cnpj, pointOfSaleId, tradeName }) => {
					const label = `${CNPJ(cnpj).mask} ${tradeName.toUpperCase()}`;
					const isSelected = pointOfSaleId === selectedPosId;

					return {
						label: (
							<Typography
								textAlign="inherit"
								fontSize={getTypographyMetric(fontSizes['16'])}
								fontWeight="400"
								lineHeight={getTypographyMetric(fontSizes['24'])}
								color="--greys-900"
								data-header-pos-label={isSelected ? 'selected' : 'available'}
								textEllipsis={1}
								title={label}
							>
								{label}
							</Typography>
						),
						value: pointOfSaleId,
						disabled: isSelected,
					};
				})}
				direction="column"
				disabled={disabled}
				innerGap="8px"
				name="posList"
				outerGap="16px"
				onChange={({ currentTarget: { value } }) => onChangePos(value)}
				value={selectedPosId}
			/>
		</HeaderSelectorSkeletonsRender>
	);
}
